import { useQuery } from '@tanstack/react-query';
import { getProducts, type ProductsResponse } from '../api';

/**
 * Hook to fetch products for complaint form (brand + optional supplier)
 * @param supplierId - Optional supplier ID to include vendor-specific products
 * @param enabled - Whether to fetch (requires brand context)
 */
export function useProducts(supplierId?: string, enabled = true) {
  return useQuery({
    queryKey: ['products', supplierId ?? 'brand-only'],
    queryFn: async (): Promise<ProductsResponse> => {
      return getProducts(supplierId);
    },
    enabled,
    staleTime: 2 * 60 * 1000, // Cache for 2 minutes
  });
}
